import './all.css';

import {useState, useRef} from 'react';
import Home from './Home'
import Download from './Download'

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams
} from "react-router-dom";

function App() {
  return <Router>
  <Routes>
      <Route
        path="/"
        element={<Home />}
      />
      <Route
        path="/:fileid"
        element={<Download />}
      />
    </Routes>
    </Router>
}

export default App